import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { TelegramLoginButton } from '../components/TelegramLoginButton';
import { useAuth } from '../hooks/useAuth';

export function LoginPage() {
  const { user, config, loading } = useAuth();
  const [error, setError] = useState<string | null>(null);

  if (loading) return <p className="muted">Загрузка…</p>;
  if (user) return <Navigate to="/" replace />;

  return (
    <div style={{ maxWidth: 420, margin: '3rem auto' }}>
      <div className="card" style={{ textAlign: 'center' }}>
        <h1 style={{ marginTop: 0 }}>YourProv</h1>
        <p className="muted">Войдите через Telegram, чтобы управлять подпиской и VPN</p>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1.5rem' }}>
          <TelegramLoginButton
            botUsername={config?.bot_username ?? ''}
            onError={setError}
          />
        </div>
        {error && <p className="error-text" style={{ marginTop: '1rem' }}>{error}</p>}
        <p className="muted" style={{ marginTop: '1.5rem', fontSize: '0.8rem' }}>
          Нет аккаунта? Запустите бота в Telegram — регистрация произойдёт автоматически при входе.
        </p>
      </div>
    </div>
  );
}
